import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'delete-voucher-template-dialog',
    templateUrl: './deleteVoucherTemplateDialog.component.html',
    styleUrls: ['./deleteVoucherTemplateDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class DeleteVoucherTemplateDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;


    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<DeleteVoucherTemplateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.translationLoader.loadTranslations(polish);
    }
}
